import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Mirrors the (currently unused) ProtectedRoute, but gates on the is_admin
// flag /api/auth/check returns. This only hides the UI -- every /api/admin
// route re-checks the ADMIN_EMAILS allowlist server-side, so a non-admin who
// guesses the URL gets a 403, not data.
function AdminRoute({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login?redirect=/admin" replace />;
  }

  // Deliberately bounces to the dashboard rather than showing a "forbidden"
  // page: a non-admin has no reason to learn the console exists.
  if (!user?.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default AdminRoute;
